import { createContext } from 'react';
const LeadContext = createContext();
export default LeadContext;
